import { ReactNode } from 'react';
import Link from 'next-intl/link';
import { MdChevronRight, MdHome } from 'react-icons/md';

type CrumbItem = {
  label: ReactNode;
  path: string;
  id?: number;
};

type BreadcrumbsProps = {
  items: CrumbItem[];
};

function createHrefFor3rdCategory(category: CrumbItem): string {
  const pathParts = category.path.split('/');
  pathParts.pop(); // remove the last part
  const basePath = pathParts.join('/');
  return `${basePath}?category_id=${category.id}`;
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <ul className='flex flex-wrap items-center gap-1 text-sm uppercase tracking-widest text-[#ccc]'>
      <li>
        <Link href={'/'} className='hover:underline'>
          <MdHome />
        </Link>
      </li>
      <li>
        <MdChevronRight />
      </li>

      {items.map((crumb, i) => {
        const isLastItem = i === items.length - 1;
        const isThirdCategory = i === 2 && crumb.id !== undefined;

        const href = isThirdCategory
          ? createHrefFor3rdCategory(crumb)
          : crumb.path;
        console.log('isThirdCategory', isThirdCategory);
        if (i === 0 && !isLastItem) {
          return (
            <li key={i} className='flex items-center'>
              <Link
                href={href}
                key={i}
                className='hover:text-white hover:underline'
              >
                {crumb.label}
              </Link>
              <MdChevronRight />
            </li>
          );
        }
        if (!isLastItem) {
          return (
            <li key={i} className='flex items-center'>
              <Link
                href={href}
                className='flex items-center hover:text-white hover:underline'
              >
                {crumb.label}
              </Link>
              <MdChevronRight />
            </li>
          );
        } else {
          return (
            <li key={i}>
              <Link
                href={href}
                className='flex items-center hover:text-white hover:underline'
              >
                {crumb.label}
              </Link>
            </li>
          );
        }
      })}
    </ul>
  );
}
